import { memoizeFunction } from '@fluentui/react/lib/Utilities';
import { FontSizes, mergeStyleSets } from '@fluentui/react/lib/Styling';
export var controlDimensions = {
    maxWidth: 1400,
    minWidth: 75,
    chevronHeight: 10,
};
export var getDocumentTitleButtonStyles = memoizeFunction(function (colors) {
    return {
        root: {
            minWidth: controlDimensions.minWidth,
            padding: '0 6px',
            color: colors.defaultText,
            fontSize: FontSizes.medium,
        },
        rootHovered: {
            color: colors.hoverText,
            selectors: {
                svg: {
                    fill: colors.hoverText,
                },
            },
        },
        rootPressed: {
            color: colors.hoverText,
            selectors: {
                svg: {
                    fill: colors.hoverText,
                },
            },
        },
    };
});
export var getDocumentTitleStyles = memoizeFunction(function (colors) {
    return mergeStyleSets({
        documentTitle: {
            maxWidth: controlDimensions.maxWidth,
            padding: '0 4px',
            textOverflow: 'ellipsis',
            overflow: 'hidden',
            whiteSpace: 'nowrap',
        },
        documentTitleSeparator: {
            padding: '0 2px',
        },
        documentTitleContainer: {
            display: 'flex',
            justifyContent: 'center',
            minWidth: controlDimensions.minWidth,
        },
        buttonWrapper: {
            minWidth: controlDimensions.minWidth,
            display: 'flex',
        },
        chevron: {
            display: 'flex',
            paddingTop: 1,
            fill: colors.defaultText,
            height: controlDimensions.chevronHeight,
            width: controlDimensions.chevronHeight,
            minWidth: controlDimensions.chevronHeight,
            lineHeight: controlDimensions.chevronHeight,
            selectors: {
                ':hover': {
                    fill: colors.hoverText,
                },
            },
        },
        sharedIcon: {
            fill: colors.defaultText,
            display: 'flex',
            position: 'relative',
            paddingBottom: 5,
            paddingLeft: 2,
            paddingRight: 2,
            width: 16,
        },
    });
});
export var getDocumentTitleToolTipStyles = memoizeFunction(function () {
    return { root: { display: 'inline-block' } };
});
//# sourceMappingURL=DocumentTitle.styles.js.map